import React from 'react'
import ReactDOM from 'react-dom'

import { Link } from "react-router-dom";
import Container from '@material-ui/core/Container';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import Icon from '@material-ui/core/Icon';
import BookIcon from '@material-ui/icons/Book';

import { withStyles } from '@material-ui/core/styles';
//import Link from '@material-ui/core/Link';
import StackGrid, { transitions } from "react-stack-grid";
const { fade, fadeUp, fadeDown } = transitions;
import {isMobile} from 'react-device-detect';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Box from '@material-ui/core/Box';
import Skeleton from '@material-ui/lab/Skeleton';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import Search from '@material-ui/icons/Search';
import { InView } from 'react-intersection-observer';



import homeImage from '../images/IMG_0016-20.jpg';

const styles = theme => ({
  home: {
    maxWidth: "none",
    padding: 0,
    width: "100%",
  },
  titleSection: {
      backgroundImage: `url(${homeImage})`,
      backgroundSize: "cover",
      height: 350,
      maxWidth: "none",
      padding: 0,
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      borderBottom: "20px solid #ff6f00",
  },
  overlay: {
    position: 'relative',
    top: 0,
    height: 350,
    background: "linear-gradient(-200deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.7) 53%, rgba(0, 0, 0, 0.2) 100%)"
  },

  homeTitle: {
    position: "relative",
    top: 125,
    textAlign: "center",
  },
  mobileTitle: {
    position: "relative",
    top: 75,
    textAlign: "center",
  },

  recipeCard: {
    height: "500px",
  },

  photo: {
    maxWidth: '100%',
    height: '500px',
    borderRadius: '.25rem!important',
    verticalAlign: "middle",
    borderStyle: "none",
    backgroundSize: 'cover',
  },
  caption: {
    width: '100%',
    height: "65px",
    position: "absolute",
    bottom: 0,
    backgroundColor: "rgba(254,248,240, .80)",
    color: "rgba(0,0,0,.75)",
    padding: 10,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  captionText: {
    flex: 5,
    fontWeight: "600",
    textTransform: "uppercase",
  },

  sodiumBubble: {
    backgroundColor: "#ff6f00",
    borderRadius: "5px 20px 5px",
    color: "#FFF",
    flex: 1,
    fontSize: "8pt",
    fontWeight: "600",
    height: "60px",
    maxWidth: "60px",
    paddingTop: 20,
    textAlign: "center",
    textTransform: "uppercase",

  },

  book: {
    color: theme.palette.secondary.main,
    fontSize: "10pt",
  },
  searchField: {
    backgroundColor: "rgba(250, 250, 250, .9)",
    marginTop: 20,
    width: '40%',
  },

  recipeGroup: {
    borderBottom: "20px solid #ff6f00",
  },

  recipeGroupHeader: {
    padding: 15,
    textAlign: "center",
    color: theme.palette.secondary.main,
    fontSize: 16,
  }

});

class Recipes extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showFeatured: true,
      selectedRecipes: Array.from(new Array(10)),
      recipes: [],
      shownCount: 10,
      loading: true,
    }
  }

  async componentDidMount() {
    await this.getFeatured();
    await this.getRecipes();
  }

  async getFeatured() {
     fetch('/api/v1/recipes/latest', {
      method: 'GET',
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      }
    }).then((response) => {
      return response.json();
    }).then((data) => {
      console.log('num featured:', data.length, this.state.showFeatured);
      this.setState({featuredRecipes: data});
    });
  }


  async getRecipes() {
     fetch('/api/v1/recipes', {
      method: 'GET',
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      }
    }).then((response) => {
      return response.json();
    }).then((data) => {
      // start with only the first 20 selected shown
      this.setState({recipes: data, selectedRecipes: data.slice(0, 10) });
      this.setState({shownCount: 10});
      this.setState({loading: false});
    });
  }

  searchNow(event) {
    if (event.target.value.length > 1) {
      let selected = this.state.recipes.filter((recipe) => {
        return recipe.name.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1;
      });
      this.setState({selectedRecipes: selected, showFeatured: false});
    } else {
      this.setState({selectedRecipes: this.state.recipes, showFeatured: true});
    }
  }

  showMore(isVisible) {
    if (isVisible) {
      let numToShow = this.state.shownCount + 10;
      this.setState({selectedRecipes: this.state.recipes.slice(0, numToShow), shownCount: numToShow});
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <Container className={classes.home}>

        <Container className={classes.titleSection}>
          <div className={classes.overlay}>
          <div className={classes.homeTitle}>

            <Typography
              align="center"
              variant={isMobile ? "h3" : "h2"}
              color="primary"
              >
              Find a Recipe
            </Typography>

            <TextField
              id="search"
              label="Search"
              variant="filled"
              color="secondary"
              maxLength={100}
              className={classes.searchField}
              onChange={(event) => this.searchNow(event)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}

              />

          </div>
          </div>
        </Container>

        {( !!this.state.featuredRecipes && this.state.showFeatured &&
          <div className={classes.recipeGroup}>
            <div className={classes.recipeGroupHeader}>
              Newest Recipes
            </div>

            <StackGrid
              columnWidth={350}
              enter={fade.enter}
              entered={fade.entered}
              leaved={fadeUp.leaved}
            >
              {this.state.featuredRecipes.map((item, index) => (
                <Link key={index} to={`/recipe/${item.id}`}>
                  <div
                    className="recipeCard">
                    <div
                      className={classes.photo}
                      style={{backgroundImage: `url(${item.thumb_image})` }}
                      alt={item.name} />
                    <div className={classes.caption}>
                      <div className={classes.captionText}>
                        {item.name}
                        {( !!item.page_number &&
                        <BookIcon titleAccess={`You can find this recipe in ${item.book_name}`} className={classes.book}/>
                        )}

                      </div>
                      {( !!item.sodium_per_serving &&
                      <div
                        title={`${item.sodium_per_serving} sodium per serving`}
                        className={classes.sodiumBubble}>
                        {item.sodium_per_serving}
                      </div>
                      )}
                    </div>
                  </div>
                </Link>
              ))}
            </StackGrid>
          </div>
        )}

        {( !this.state.loading &&
          <div >
            <div className={classes.recipeGroupHeader}>
              All Recipes
            </div>

          <StackGrid
            columnWidth={350}
            enter={fade.enter}
            entered={fade.entered}
            leaved={fadeUp.leaved}
          >
            {this.state.selectedRecipes.map((item, index) => (
              <Link key={index} to={`/recipe/${item.id}`}>
                <div
                  className="recipeCard">
                  <div
                    className={classes.photo}
                    style={{backgroundImage: `url(${item.thumb_image})` }}
                    alt={item.name} />
                  <div className={classes.caption}>
                    <div className={classes.captionText}>
                      {item.name}
                      {( !!item.page_number &&
                      <BookIcon titleAccess={`You can find this recipe in ${item.book_name}`} className={classes.book}/>
                      )}

                    </div>
                    {( !!item.sodium_per_serving &&
                    <div
                      title={`${item.sodium_per_serving} sodium per serving`}
                      className={classes.sodiumBubble}>
                      {item.sodium_per_serving}
                    </div>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </StackGrid>

          {( this.state.showFeatured &&
            <InView onChange={(inView, entry) => this.showMore(inView)}>
              {( this.state.shownCount < this.state.recipes.length &&
                <div className={classes.recipeGroupHeader}>
                  Loading More
                </div>
              )}
            </InView>
          )}
          </div>

        )}

        {( this.state.loading &&
          <StackGrid
            columnWidth={350}
            appear={fadeDown.appear}
            appeared={fadeDown.appeared}
            enter={fade.enter}
            entered={fade.entered}
          >
          {this.state.selectedRecipes.map((item, index) => (
            <Box key={index} height={500}>
              <Skeleton height={400} />
              <Skeleton width="60%" />
            </Box>
          ))}
        </StackGrid>

        )}

      </Container>
    )
  }
}


export default withStyles(styles)(Recipes);
